import { createFileRoute } from "@tanstack/react-router";
import { RelatorioAnaliseQualidade } from "pages/relatorios/pages/analise_qualidade";

export const Route = createFileRoute("/a/relatorios/analise-qualidade")({
	component: RelatorioAnaliseQualidade,
});
